/**
 * Component to show a list of subscription orders.  
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Grid, TableContainer, Table,  TableBody, TableCell, TableHead, TableRow, TablePagination, Typography, Tooltip, Button} from '@mui/material';
import CheckCircle from '@mui/icons-material/CheckCircle';
import Cancel from '@mui/icons-material/Cancel';
import { format } from 'date-fns';


import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';
import { green, red } from '@mui/material/colors';
import ConfirmationDialog from '../ui/ConfirmationDialog';

const abEnvironment = new AbEnvironment();

const ProjectsQuery = graphql`
query ProjectsQuery($accountId: UUID!, $pAccountId: UUID!, $first: Int, $offset: Int) {
  projectsForProvisioner : allProjectTs(condition: {resellerAccountId: $pAccountId}, first: $first, offset: $offset, orderBy: PROJECT_START_DESC) {
    totalCount
    nodes {
      projectId
      projectName
      projectStart
      projectStatus
      accountTByResellerAccountId {
        accountId
        accountName
      }
      accountTByCustomerAccountId {
        accountId
        accountName
      }
    }
  }
  projectsForCustomer : allProjectTs(condition: {customerAccountId: $accountId}, first: $first, offset: $offset, orderBy: PROJECT_START_DESC) {
    totalCount
    nodes {
      projectId
      projectName
      projectStart
      projectStatus
      accountTByResellerAccountId {
        accountId
        accountName
      }
      accountTByCustomerAccountId {
        accountId
        accountName
      }      
    }
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
      // marginTop: -32,
    },
    flex: {
      flex: 1,
    },
    formControl: {
      marginBottom: '24',
    },
    nselect: {
      minWidth: 100
    },
    divider: {
      marginTop: 4,
      marginBottom: 4,
      marginLeft: 0,
    },
    button: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    dateField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginTop: 4,
      width: 180,
    },
    textField2: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginTop: 3,
      width: 160,
    },
      paper1: {
      padding: 16,
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    paper2: {
      padding: 12,
      textAlign: 'left',
      color: theme.palette.text.secondary,
    },
    paper3: {
      padding: 16,
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    topButton: {
      marginTop: 15
    },
    paper: {
      width: '100%',
      marginTop: theme.spacing(1),
      overflow: 'auto',
    },
    tblHead: {
      backgroundColor: '#f1f1f1',
    },
    tblHeadRow: {
      height: 32,
    },
    tblHeadCell: {
      textAlign: 'left',
      verticalAlign: 'bottom',
      borderBottom: 0,
    },
    tblHeadCellB: {
      textAlign: 'right',
      verticalAlign: 'bottom',
    },
    tblHeadCellC: {
      textAlign: 'center',
      verticalAlign: 'bottom',
      borderBottom: 0,
    },
    /*
    link: {
      fontSize: 14
    }*/

});


class Projects extends Component {


  constructor(props) {
    super(props);

    this.state = {
      forceFetch:        0,
      page:              0,
      rowsPerPage:       5,
      confirmClose: false,
      requestCloseSpinner: false,
      projectToClose:    null,
      projectToCloseName: ''
    };  
  }

  componentDidMount() {


  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
      page: 0,
    });
  };

  handleChangePage = (event, page) => {
    this.setState({page: page});
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value, page : 0});
  }

  goTo(route) {

    this.props.history.push(`/${route}`);
  }

  setParentTab = (tv) => {
    if (this.props.setTabVal) {
      this.props.setTabVal(tv);
    }
  }



  render() {
    const { isAuthenticated, isAuthenticatedReseller, isAuthenticatedCustomer, isAuthenticatedAppBind, isUnauthenticatedCustomer, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    if (!isAuthenticated() || needAssent()) { 
      return ( <Redirect to='/home' /> );
    }    
    if (!isAuthenticatedCustomer() && !isUnauthenticatedCustomer() && !isAuthenticatedReseller() && !isAuthenticatedAppBind()) {
      // others cannot see this component
      return ( <Redirect to='/home' /> );
    } 
    const statusOk = green[300];
    const cancelColor = red[300];
 
    // Determine the offset
    let offset = 0;
    if (this.state.page > 0) {
      offset = this.state.page * this.state.rowsPerPage
    }
    let first = this.state.rowsPerPage;


    let acctId = abEnvironment.getUserAttribute("a_id");

    return (
      <div className={classes.root}>
        <Grid container spacing={0} direction="row" justifyContent={"space-between"}>
          <Grid item>
            <Typography variant="h6">
              Projects
            </Typography>
          </Grid>


        </Grid>


        <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={ProjectsQuery}
          variables={{
            accountId: acctId,
            pAccountId: acctId,
            forceFetch: this.state.forceFetch,
            first: first,
            offset: offset
          }}
          render={({ error, props }) => {
            if (error) {
              logError(error.message);
              return (
                <ServerError/>
              );
            } else if (props) {


              let totalCount = 0;
              let theProjects = 0;

              if (isAuthenticatedReseller()) {
                totalCount = props.projectsForProvisioner.totalCount;
                theProjects = props.projectsForProvisioner.nodes;
  
              } else {
                totalCount = props.projectsForCustomer.totalCount;
                theProjects = props.projectsForCustomer.nodes;

              }

              
              return (
                <div className={classes.paper}>

                  <Grid container spacing={2} direction="row" justifyContent="flex-start">


                  <Grid item xs={12}>
                    <TableContainer>
                      <Table>
                        <TableHead className={classes.tblHead}>
                          <TableRow className={classes.tblHeadRow}>
                            <TableCell className={classes.tblHeadCell}>Project</TableCell>
                            <TableCell className={classes.tblHeadCell}>Start date</TableCell>
                            {isAuthenticatedReseller() &&
                            <TableCell className={classes.tblHeadCell}>Customer</TableCell>
                            }
                            {(isAuthenticatedCustomer() || isUnauthenticatedCustomer()) &&
                            <TableCell className={classes.tblHeadCell}>Reseller</TableCell>
                            }
                            <TableCell className={classes.tblHeadCellC}>Status</TableCell>
                            <TableCell className={classes.tblHeadCellC}></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>



                        {theProjects.map(n => {

                          //hide projects whose reseller and customer id are the same
                          if (n.accountTByCustomerAccountId && n.accountTByResellerAccountId) {
                            if (n.accountTByCustomerAccountId.accountId ===  n.accountTByResellerAccountId.accountId) {
                                return (null);
                            }
                          }

                          let projectStart = format(new Date(n.projectStart), 'yyyy-MM-dd');
                          return (
                            <TableRow key={n.projectId}>
                              <TableCell><Typography variant="body2">{n.projectName}</Typography></TableCell>
                              <TableCell><Typography variant="body2">{projectStart}</Typography></TableCell>
                              {isAuthenticatedReseller() &&
                              <TableCell >{n.accountTByCustomerAccountId.accountName}</TableCell>
                              }
                              {(isAuthenticatedCustomer() || isUnauthenticatedCustomer()) &&
                              <TableCell >{n.accountTByResellerAccountId.accountName}</TableCell>
                              }
                              <TableCell align="center">
                                {n.projectStatus === 0 &&
                                  <Tooltip title='This subscription order is active'>
                                    <CheckCircle htmlColor={statusOk} />
                                  </Tooltip>
                                }
                                {n.projectStatus === 1 &&
                                  <Tooltip title='This project has been closed'>
                                    <Cancel htmlColor={cancelColor} />
                                  </Tooltip>
                                }
                              </TableCell>
                                {n.projectStatus === 0 &&
                                 <TableCell align="center">
                                  <Tooltip placement='bottom' title="Close the project">
                                    <Button variant="outlined" onClick={() => { this.setState({confirmClose: true, projectToClose: n.projectId, projectToCloseName: n.projectName}); }}>Close</Button>
                                  </Tooltip>
                                </TableCell>
                              }
                               {n.projectStatus === 1 &&
                                  <TableCell></TableCell>
                                }
                            </TableRow>

                          )

                        })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <div style={{ marginTop: '10px' }}>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={totalCount}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        backIconButtonProps={{
                          'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                          'aria-label': 'Next Page',
                        }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                      />
                    </div>
                    </Grid>
                    <ConfirmationDialog
                        open={this.state.confirmClose}
                        onClose={() => { this.setState({confirmClose:false});}}
                        onConfirm={() => { this.closeProject(this.state.projectToClose, theProjects); }}
                        onCancel={() => { }}
                        title="Close project"
                        cancelBtn="Cancel"
                        okBtn="Ok"
                        irreversibleAction={true}
                      >
                        {'Subscriptions will no longer be allowed to be added, services will be cancelled and the project will be marked closed.  Are you sure that you want to close project ' + this.state.projectToCloseName + '?'}
                    </ConfirmationDialog>  
                  </Grid>
                </div>
              )
            }
            return (
              <LoadingSpinner />
            );
          }}
        />


      </div>
    );
  }

  closeProject(projectId, projects) {
    const { callPartnerApi } = this.props.auth;

    let project = projects.filter(project => project.projectId === projectId);

    let forceFetch = this.state.forceFetch;
    forceFetch++;

    let payload = {
      operation: "closeProject",
      params: {
        projectId: projectId,
        accountId: project[0].accountTByCustomerAccountId.accountId,
        pAccountId: project[0].accountTByResellerAccountId.accountId     
      }
    };

    callPartnerApi('appbind/generic',
                     'POST',
                     payload
    )
    .then((response) => {
      return response.json();
    })
    .then(() => {
      this.setState({ showTopupSpinner: false, forceFetch: forceFetch });      
    })
    .catch(err => {
      this.setState({ showTopupSpinner: false });
    });
  }

}

Projects.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(Projects);
